
const Candidate_details = {
    text: 'Candidate Details',
    link: '/candidate-details',
    icon: 'icon-user',
    
};




export const menu = [
   
   
    Candidate_details,
  
    
    
   
];
